import { Environment, IAppConfiguration } from "./IApp.config";
import developmentConfig from "./app.config.development.json";
import preproductionConfig from "./app.config.preproduction.json";
import productionConfig from "./app.config.production.json";

const environment = process.env.REACT_APP_ENV as Environment || "development";

const getConfiguration = (): IAppConfiguration => {
    switch (environment) {
        case "development":
            return developmentConfig as IAppConfiguration;
        case "preproduction":
            return preproductionConfig as IAppConfiguration;
        case "production":
            return productionConfig as IAppConfiguration;
        default:
            return developmentConfig as IAppConfiguration;
    }
};

export const appConfiguration: IAppConfiguration = getConfiguration();